import React, { Component } from "react";
import './personalloanads.css';

class PersonalLoanATM extends Component {
  render() {
    return (
      <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 a-breadcrumbs" style={{color: '#ffffff'}}>
                <a href="/home" className="a-breadcrumbs">หน้าแรก</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการด้านสินเชื่อ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">เงินกู้ฉุกเฉิน</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="/personalloanforhome" className="a-breadcrumbs">เงินกู้ฉุกเฉิน ATM</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{width: '90%', fontFamily: '"Cordia New"'}}>
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>เงินกู้เพื่อเหตุฉุกเฉิน ผ่านบัตร ATM ธนาคารกรุงศรี</span></h2>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th style={{width: 150}}>สิทธิ</th>
                      <th style={{width: 150}}>เงินกู้เพื่อเหตุฉุกเฉิน</th>
                      <th>เงื่อนไข</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{width: 250}}>อายุงานไม่ถึง 1 ปี</td>
                      <td style={{width: 250}}>10,000 บาท</td>
                      <td rowSpan={5}>
                        <ul className="mb-25">
                          <li>เงินกู้เพื่อเหตุฉุกเฉินและเงินกู้เพื่อเหตุฉุกเฉินผ่านระบบของธนาคาร กู้ได้อย่างใดอย่างหนึ่ง จะกู้พร้อมกันทั้ง 2 ประเภทไม่ได้</li>
                          <li>ผ่อนได้สูงสุด 12 งวด</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>อายุงาน 1 ปีขึ้นไป แต่ไม่ถึง 2 ปี</td>
                      <td>20,000 บาท</td>
                    </tr>
                    <tr>
                      <td>อายุงาน 2 ปีขึ้นไป แต่ไม่ถึง 3 ปี</td>
                      <td>30,000 บาท</td>
                    </tr>
                    <tr>
                      <td>อายุงาน 3 ปีขึ้นไป แต่ไม่ถึง 4 ปี</td>
                      <td>40,000 บาท</td>
                    </tr>
                    <tr>
                      <td>อายุงาน 4 ปีขึ้นไป</td>
                      <td>50,000 บาท</td>
                    </tr>
                  </tbody>
                </table>
                <h3>ขั้นตอนการกู้เงินเพื่อเหตุฉุกเฉิน ผ่านบัตร ATM ธนาคารกรุงศรี</h3>
                <ul className="mb-25">
                  <li>สมาชิกที่จะกู้ฉุกเฉิน ATM ต้องไม่มีภาระหนี้ค้างชำระในประเภทเงินกู้ฉุกเฉิน</li>
                  <li>ติดต่อเปิดบัญชีออมทรัพย์ธนาคารกรุงศรีพร้อมบัตร ATM สำหรับใช้กับสหกรณ์ <u><a href="Form/รายละเอียดติดต่อเปิดบัญชีกรุงศรี.pdf" target="_blank" style={{color: '#4db6f1'}}>คลิกใบนำส่งเปิดบัญชี</a></u></li>
                  <li>ยื่นคำขอกู้ผ่านทาง <u><a href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" target="_blank" style={{color: '#4db6f1'}}>ระบบข้อมูลสมาชิกออนไลน์</a></u> พร้อมแนบสำเนาหน้าสมุดบัญชีธนาคารกรุงศรี</li>
                  <li>รอรับสัญญากู้เงินเพื่อเหตุฉุกเฉินทาง E-mail</li>
                  <li>ส่งสัญญาที่ลงนามครบถ้วนมาที่สหกรณ์ </li>
                  <li>สมาชิกจะกดเงินได้ในวันที่สหกรณ์ได้รับสัญญาที่ลงนามฉบับจริง</li>
                  <li>ค่าธรรมเนียมการกดเงินกู้ผ่านตู้ ATM ธนาคารกรุงศรี ในพื้นที่ครั้งละ 8.- บ. นอกพื้นที่ครั้งละ 15.- บ.</li>
                  <li>เมื่อสหกรณ์ดำเนินการเรียบร้อยจะแจ้งสมาชิกทาง E-mail</li>
                </ul>
                <p className="mb-20">หมายเหตุ  **การเติมวงเงินเพื่อสำรองการกู้ฉุกเฉิน ATM ทั้งกรณีสมัครใหม่ และ ผ่อนชำระรายงวดไปแล้ว สหกรณ์จะเติมวงเงินสำรองเพื่อให้สมาชิกมีวงเงินเต็มสูงสุดตามอายุงานตลอดเวลา ทุกวันที่ 25 ของเดือน**</p>
                <h3>การถอนเงินกู้ผ่านบัตร ATM</h3>
                <img src="Img/WithDrawATM/loanatm.JPG" />
              </div>
            </div>
          </div>
          {/* list*/}
        </section>
      </div>
    );
  }
}

export default PersonalLoanATM;
